import { Type } from './action-types';
import { entireVideoEnhancer } from './enhancers';
import { stateFactory } from './factories';
import { VideoUploadAction } from './types';

const defaultState = stateFactory();

function reducer(state = defaultState, action: VideoUploadAction) {
  // Enforce single-occupancy. Once a different file has claimed the slice via
  // VIDEO_UPLOAD_REQUEST, a follow-up action from a superseded upload must not
  // write into the slice that now belongs to another upload. Local-File
  // pipeline actions carry their originating `identifier`; drop them when it
  // no longer matches the slice's owner. VIDEO_UPLOAD_REQUEST is the claim
  // itself, so it is never dropped; remote and imported-media actions carry
  // no `identifier` and are unaffected.
  if (
    action.type !== Type.VIDEO_UPLOAD_REQUEST &&
    action.payload?.identifier != null &&
    action.payload.identifier !== state.get('uploadIdentifier')
  ) {
    return state;
  }

  switch (action.type) {
    case Type.VIDEO_UPLOAD_REQUEST:
      return state.withMutations(s =>
        s
          .set('isUploading', true)
          .set('uploadProgress', 0)
          .set('videoUploadOptions', undefined)
          .set('uploadIdentifier', action.payload?.identifier)
          .set('uploadedVideoId', undefined),
      );

    case Type.VIDEO_UPLOAD_PROGRESS: {
      const { progress } = action.payload;
      return state.set('uploadProgress', progress);
    }

    case Type.MULTIPART_UPLOAD_INIT_SUCCESS: {
      const { multipartAbortOptions } = action.payload;

      return state.set('multipartAbortOptions', multipartAbortOptions);
    }

    case Type.VIDEO_UPLOAD_SUCCESS: {
      const { videoUploadOptions, videoId } = action.payload ?? {};
      return state.withMutations(s =>
        s
          .set('isUploading', false)
          .set('uploadProgress', 100)
          .set('videoUploadOptions', videoUploadOptions)
          .set('multipartAbortOptions', undefined)
          .set('uploadedVideoId', videoId),
      );
    }

    case Type.VIDEO_UPLOAD_FAILURE:
      return state.withMutations(s =>
        s
          .set('isUploading', false)
          .set('uploadProgress', undefined)
          .set('videoUploadOptions', undefined)
          .set('multipartAbortOptions', undefined)
          .set('uploadIdentifier', undefined)
          .set('uploadedVideoId', undefined),
      );

    default:
      return state;
  }
}

export default entireVideoEnhancer.createReducer(reducer, defaultState);
